import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getformid, getcontroller, getsubkey, getWindowDimensions, setglobaldata, FormatDate,
    NumConv, DicVal, getglobaldata, DeepCopy, initializedata, RandomKey, Savestorage, Getstorage,
    GetDesitRound, GetRound, isEnabled
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entryformlock, entrytriggercall,readonly,reports } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));


export const ProcOrderR = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", ROW: "1", INPUT: "2", IMAGE: "pic", FILE: "file", TOTAL: "T1", HEADER: "H1" }
    const primarykeys = ["d_porder_r_hedno"];

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.staff);
    const entrylock = useSelector(state => state.form.entryformlock);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefinput = useRef({ grid: undefined, column: undefined });
    const apiRefrow1 = useRef({ grid: undefined, column: undefined });
    const apiReftotal1 = useRef({ grid: undefined, column: undefined });
    const apiRefheader1 = useRef({ grid: undefined, column: undefined });
    const apiRefrow2 = useRef({ grid: undefined, column: undefined });
    const apiReftotal2 = useRef({ grid: undefined, column: undefined });
    const apiRefheader2 = useRef({ grid: undefined, column: undefined });
    const apiRefrow3 = useRef({ grid: undefined, column: undefined });
    const apiReftotal3 = useRef({ grid: undefined, column: undefined });
    const apiRefheader3 = useRef({ grid: undefined, column: undefined });
    const apiRefrow4 = useRef({ grid: undefined, column: undefined });
    const apiReftotal4 = useRef({ grid: undefined, column: undefined });
    const apiRefheader4 = useRef({ grid: undefined, column: undefined });
    const apiRefrow5 = useRef({ grid: undefined, column: undefined });
    const apiReftotal5 = useRef({ grid: undefined, column: undefined });
    const apiRefheader5 = useRef({ grid: undefined, column: undefined });

    const apiinput = apiRefinput.current;
    const apirow = [apiRefrow1.current, apiRefrow2.current, apiRefrow3.current, apiRefrow4.current, apiRefrow5.current];
    const apitotal = [apiReftotal1.current, apiReftotal2.current, apiReftotal3.current, apiReftotal4.current, apiReftotal5.current];
    const apiheader = [apiRefheader1.current, apiRefheader2.current, apiRefheader3.current, apiRefheader4.current, apiRefheader5.current];
    const CalcParam1 = useRef({ taxrate: 0.1, amtround: 1, taxround: 1 });
    const CalcParam2 = useRef({ taxrate: 0.1, amtround: 1, taxround: 1 });
    const CalcParam3 = useRef({ taxrate: 0.1, amtround: 1, taxround: 1 });
    const CalcParam4 = useRef({ taxrate: 0.1, amtround: 1, taxround: 1 });
    const CalcParam5 = useRef({ taxrate: 0.1, amtround: 1, taxround: 1 });
    const CalcParam = [CalcParam1, CalcParam2, CalcParam3, CalcParam4, CalcParam5]
    const locationstate = useRef(null);    //遷移State

    const entrydataRef = useRef(null);    //基本情報データ
    const inputRef = useRef(null);        //投入情報データ
    const inputcolRef = useRef(null);     //投入情報列情報  
    const rowsRef1 = useRef(null);        //加工発注データ
    const rowsRef2 = useRef(null);
    const rowsRef3 = useRef(null);
    const rowsRef4 = useRef(null);
    const rowsRef5 = useRef(null);
    const rowsRef = [rowsRef1, rowsRef2, rowsRef3, rowsRef4, rowsRef5];
    const colRef = useRef(null);          //加工発注列情報
    const headerRef1 = useRef(null);     //加工発注ヘッダデータ
    const headerRef2 = useRef(null);
    const headerRef3 = useRef(null);
    const headerRef4 = useRef(null);
    const headerRef5 = useRef(null);
    const headerRef = [headerRef1, headerRef2, headerRef3, headerRef4, headerRef5];
    const headercolRef = useRef(null);    //加工発注ヘッダ列情報
    const totalRef1 = useRef(null);      //加工発注合計データ
    const totalRef2 = useRef(null);
    const totalRef3 = useRef(null);
    const totalRef4 = useRef(null);
    const totalRef5 = useRef(null);
    const totalRef = [totalRef1, totalRef2, totalRef3, totalRef4, totalRef5];
    const totalcolRef = useRef(null);   　//加工発注合計列情報
    const imageRef = useRef(null);        //画像
    const fileRef = useRef(null);         //ファイル  

    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const formlock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [rowDragManaged1, setrowDragManaged1] = useState(true);
    const [rowDragManaged2, setrowDragManaged2] = useState(true);
    const [rowDragManaged3, setrowDragManaged3] = useState(true);
    const [rowDragManaged4, setrowDragManaged4] = useState(true);
    const [rowDragManaged5, setrowDragManaged5] = useState(true);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const search = useLocation().search;

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const formid = getformid("ProcOrderR", props.location.search);
    const controller = getcontroller("ProcOrderR", props.location.search);
    const subkey = getsubkey(props.location.search);
    const reportsRef = useRef(null);

    const actionurl = {
        "insert": "procorderr/Insert",
        "update": "procorderr/Update",
        "delete": "procorderr/Delete",
        "saveas": "procorderr/SaveAs",
        "storageadd": "procorderr/AddStorage",
        "storagerowdel": "procorderr/StorageRowdel",
        "upload": "procorderr/Upload",
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "1", action: "INSERT" }
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }
    function statusKey(id) {
        return formid + "entry_" + id;
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    let p = data.panels.find(e => e.id === "1");
                    p["index"] = 0;
                    p.name = "加工発注-1"
                    p.abbr = p.name;
                    for (let i = 0; i < 4; i++) {
                        let newp = DeepCopy(p);
                        newp["index"] = i + 1;
                        newp.name = "加工発注-" + (i + 2).toString();
                        newp.abbr = newp.name;
                        data.panels.push(newp);
                    }
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    inputcolRef.current = null;
                    colRef.current = null;
                    headercolRef.current = null;
                    totalcolRef.current = null;
                    if (data.prelayout) {   //レイアウト復元
                       RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (isEmpty(entrydataRef.current)) return;
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_porder_r_hed_no"] = "";
            entrydataRef.current["d_porder_r_hed_createac"] = "";
            entrydataRef.current["d_porder_r_hed_createdate"] = "";
            entrydataRef.current["d_porder_r_hed_updateac"] = "";
            entrydataRef.current["d_porder_r_hed_update"] = "";
            //受入ロック解除
            for (let i = 0; i < rowsRef.current.length; i++) {
                rowsRef.current[i]["lockrow"] = false;
            }
            setrowDragManaged1(true);    //行入れ替え可
            setrowDragManaged2(true);
            setrowDragManaged3(true);
            setrowDragManaged4(true);
            setrowDragManaged5(true);
            setsliplock(false);
            rerender();
        }
    }, [formstatus]);

    function setsliplock(value) {
        dispatch(entryformlock(value));
    }

    //遷移state状態表示
    function callshow() {
        Show(undefined, locationstate.current.code)
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param, id, index) {
        if (id === G_id.INPUT) {
            apiRefinput.current.grid = param.api;
            apiRefinput.current.column = param.columnApi;
        }
        id = id.split('_')[0];
        if (id === G_id.HEADER) {
            switch (index) {
                case 0:
                    apiRefheader1.current.grid = param.api;
                    apiRefheader1.current.column = param.columnApi;
                    break;
                case 1:
                    apiRefheader2.current.grid = param.api;
                    apiRefheader2.current.column = param.columnApi;
                    break;
                case 2:
                    apiRefheader3.current.grid = param.api;
                    apiRefheader3.current.column = param.columnApi;
                    break;
                case 3:
                    apiRefheader4.current.grid = param.api;
                    apiRefheader4.current.column = param.columnApi;
                    break;
                case 4:
                    apiRefheader5.current.grid = param.api;
                    apiRefheader5.current.column = param.columnApi;
                    break;
                default: break;
            }
        }
        if (id === G_id.ROW) {
            switch (index) {
                case 0:
                    apiRefrow1.current.grid = param.api;
                    apiRefrow1.current.column = param.columnApi;
                    break;
                case 1:
                    apiRefrow2.current.grid = param.api;
                    apiRefrow2.current.column = param.columnApi;
                    break;
                case 2:
                    apiRefrow3.current.grid = param.api;
                    apiRefrow3.current.column = param.columnApi;
                    break;
                case 3:
                    apiRefrow4.current.grid = param.api;
                    apiRefrow4.current.column = param.columnApi;
                    break;
                case 4:
                    apiRefrow5.current.grid = param.api;
                    apiRefrow5.current.column = param.columnApi;
                    break;
                default: break;
            }
        }
        if (id === G_id.TOTAL) {
            switch (index) {
                case 0:
                    apiReftotal1.current.grid = param.api;
                    apiReftotal1.current.column = param.columnApi;
                    if (isEmpty(locationstate.current)) RowDataChanged(index);
                    break;
                case 1:
                    apiReftotal2.current.grid = param.api;
                    apiReftotal2.current.column = param.columnApi;
                    if (isEmpty(locationstate.current)) RowDataChanged(index);
                    break;
                case 2:
                    apiReftotal3.current.grid = param.api;
                    apiReftotal3.current.column = param.columnApi;
                    if (isEmpty(locationstate.current)) RowDataChanged(index);
                    break;
                case 3:
                    apiReftotal4.current.grid = param.api;
                    apiReftotal4.current.column = param.columnApi;
                    if (isEmpty(locationstate.current)) RowDataChanged(index);
                    break;
                case 4:
                    apiReftotal5.current.grid = param.api;
                    apiReftotal5.current.column = param.columnApi;
                    if (isEmpty(locationstate.current)) {
                        RowDataChanged(index);
                    } else {
                        //遷移表示
                        callshow();
                    }
                    break;
                default: break;
            }
        }
    }

    function MenuQueryAction(action, param) {
        if (action === 'delete' && formstatus === "UPDATE") {
            if (param.tabvalue !== '0') {
                fnc.current.warnmsg("このシートのデータは削除できません");
                return false;
            }
        }
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") {
            clearform(true);
        }
        if (action === 'linkfield') {
            switch (finallycallback.table) {
                case "d_porder_r":
                    let type = "100";
                    let col = textfields.find(e => e.columnid === finallycallback.field);
                    if (col !== undefined) {
                        type = col.type;
                        let key = finallycallback.field + "_" + type;
                        document.getElementById(key).focus();
                        document.getElementById(key).select();
                    }
                    Jump(G_id.BASE, type);
                    break;
                case "d_porder_r_row":
                    Jump(G_id.ROW);
                    AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, apirow.grid);
                    break;
                default:
                    break;
            }
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('procorderr/GetDataTree', { "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        if (code === "") {
            let col = textfields.find(e => e.columnid === "d_porder_r_acceptno");
            if (!isEmpty(col)) col.locked = true;    //受入番号無効
            settextfields(textfields);
        }
        clearform(code==="");
        //データ読み込み
        LoadData(code);
        return true;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('procorderr/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_porder_r_memo" in row) data.data.d_porder_r_memo = row.d_porder_r_memo;
                                if ("d_porder_r_sticky" in row) data.data.d_porder_r_sticky = row.d_porder_r_sticky;
                                if ("d_porder_r_mytags" in row) data.data.d_porder_r_mytags = row.d_porder_r_mytags;
                            }
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            inputRef.current = data.input;
                            var totalfields = ["d_porder_r_qty", "d_porder_r_amount", "d_porder_r_tax", "d_porder_r_taxinamt", "d_porder_r_taxkind",
                                "d_porder_r_rate", "d_porder_r_currencyamt"];
                            var totalcols = columninfo.filter(e => e.logpid === "T1");
                            for (let i = 0; i < totalcols.length; i++) {
                                if (totalfields.indexOf(totalcols[i].columnid) === -1)
                                    totalfields.push(totalcols[i].columnid);
                            }
                            initRef();
                            for (let i = 0; i < 5; i++) {
                                if (data.row[i].rowdata.length === 0) {
                                    continue;
                                }
                                let hed = data.row[i].data;
                                headerRef[i].current = [hed];
                                rowsRef[i].current = data.row[i].rowdata;
                                var total = { rowid: "TOTAL", grip: "計" };
                                for (let j = 0; j < totalfields.length; j++) {
                                    total[totalfields[j]] = hed[totalfields[j]];
                                }
                                totalRef.current = [total];
                                CalcParam[i].current = {
                                    taxrate: hed["taxrate"], amtround: hed["m_splr_roundamt"], taxround: hed["m_splr_roundtax"],
                                    taxdate: FormatDate(hed["d_porder_r_date"]), splrcode: hed["d_porder_r_splr"]
                                };
                                //受入済の場合行入れ替え不可
                                let lock = data.row[i].rowdata.some(e => e.lockrow);
                                setrowDragManaged(i, !lock);
                            }
                            imageRef.current = data.images;
                            fileRef.current = data.files;
                            dispatch(setimagelist(data.images));
                            setsliplock(data.data["d_porder_r_hed_lock"] !== "0");   //伝票ロックか
                            rerender();
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }
    function setrowDragManaged(idx, lock) {
        switch (idx) {
            case 0: setrowDragManaged1(lock); break;
            case 1: setrowDragManaged2(lock); break;
            case 2: setrowDragManaged3(lock); break;
            case 3: setrowDragManaged4(lock); break;
            case 4: setrowDragManaged5(lock); break;
            default: break;
        }
    }
    function rowDragManaged(idx) {
        switch (idx) {
            case 0: return rowDragManaged1;
            case 1: return rowDragManaged2;
            case 2: return rowDragManaged3;
            case 3: return rowDragManaged4;
            case 4: return rowDragManaged5;
            default: return null;
        }
    }

    //リストValueChange
    function ListCellChange(params, columninfo, tabvalue) {
        //簡易計算処理
        var data = null;
        if (tabvalue !== "1") return data;
        if (params.colDef.field === "d_porder_r_row_qty") {
            if (columninfo.some(e => e.columnid === "d_porder_r_row_amount") && columninfo.some(e => e.columnid === "d_porder_r_row_price")) {
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_porder_r_row_price", 0));
                value = GetRound(value, 1);   //四捨五入暫定
                if (data === null) data = {};
                data['d_porder_r_row_amount']=value;
            }
        }
        if (params.colDef.field === "d_porder_r_row_price") {
            if (columninfo.some(e => e.columnid === "d_porder_r_row_amount") && columninfo.some(e => e.columnid === "d_porder_r_row_qty")) {
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_porder_r_row_qty", 0));
                value = GetRound(value, 1);   //四捨五入暫定
                data = { d_porder_r_row_amount: value };
            }
        }
        if (params.colDef.field === "d_porder_r_row_currency") {
            if (columninfo.some(e => e.columnid === "d_porder_r_row_currencyamt") && columninfo.some(e => e.columnid === "d_porder_r_row_qty")) {
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_porder_r_row_qty", 0));
                let col = columninfo.find(e => e.columnid === "d_porder_r_row_currency");
                if (!isEmpty(col)) {
                    value = GetDesitRound(value, 1, col.decimalplace);   //四捨五入暫定
                }
                data = { d_porder_r_row_currencyamt: value };
            }
        }
        return data;
    }

　  //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            if (params.colDef.field === "d_porder_r_mytags" ||
                params.colDef.field === "d_porder_r_sharetags" ||
                params.colDef.field === "d_porder_r_sticky" ||
                params.colDef.field === "d_porder_r_memo") {
                return false;
            }
        }
        if (!edit) return edit;
        if (status === "UPDATE") {
            if (DicVal(params.data, "d_porder_r_lock", "") === "1") return false;    //伝票ロック
            if (params.colDef.field === "d_porder_r_row_code" ||
                params.colDef.field === "d_porder_r_row_colno" ||
                params.colDef.field === "d_porder_r_row_colnm" ||
                params.colDef.field === "d_porder_r_row_size" ||
                params.colDef.field === "d_porder_r_row_sizenm") {
                return false;   //編集不可　判定困難なため暫定
            }
        }
        return edit;
    }
    //明細カラム定義
    function ColdefSpecial(column) {
        if (formstatus !== "ENTRY FORM") return;
        //受入されている場合編集不可
        if (column.field === "d_porder_r_row_code" ||
            column.field === "d_porder_r_row_colno" ||
            column.field === "d_porder_r_row_colnm") {
            column.editable = function (params) {
                if (params.context.entrylock) return false;
                else
                    return !isEnabled(params.node.data["lockrow"]);
            }
            column.cellStyle = function (params) {
                if (!params.context.entrylock && isEnabled(params.node.data["lockrow"])) {
                    return { backgroundColor: '#eee' };
                } else {
                    return null;
                }
            }
        }
    }

    function Save(finallycallback) {
        storeRowData();
        if (!AGRef.current.ExistValidRow(inputRef.current, columninfo, inputcolRef.current)) {
            fnc.current.warnmsg("有効な投入明細が存在しません");
            return;
        }
        let row = [];
        let exist = false;
        for (let i = 0; i < 5; i++) {
            if (AGRef.current.ExistValidRow(headerRef[i].current, columninfo, headerRef1.current) ||
                AGRef.current.ExistValidRow(totalRef[i].current, columninfo, totalRef1.current)) {
                if (!AGRef.current.ExistValidRow(rowsRef[i].current, columninfo, colRef.current)) {
                    fnc.current.warnmsg("加工発注" + (i+1).toString() + "の明細が存在しません");
                    return;
                }
            }
            if (AGRef.current.ExistValidRow(rowsRef[i].current, columninfo, colRef.current)) {
                exist = true;
                let rdata = { "rowdata": rowsRef[i].current};
                rdata["data"] = headerRef[i].current[0];
                if (!isEmpty(totalRef[i].current)) {
                    for (let key in totalRef[i].current[0]) {
                        if (key === "rowid") continue;
                        rdata["data"][key] = totalRef[i].current[0][key]
                    }
                }
                rdata["data"]["slipindex"] = i;  //加工発注Index
                row.push(rdata);
            }
        }
        if (!exist) {
            fnc.current.warnmsg("有効な加工発注が存在しません");
            return;
        }
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        Apply();

        function Apply() {
            if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
            const paramdata = {
                "controller": formid,
                "data": entrydataRef.current,
                "input": inputRef.current,
                "row":row,
                "images": imageRef.current,
                "files": fileRef.current,
                "colinfo": columninfo,
                "code": edittingcode
            }
            fnc.current.postaxios(formstatus === "ENTRY FORM" ? "procorderr/UpdateEntry" : "procorderr/InsertEntry", paramdata,
                {
                    onSuccess: function (data) {
                        if (data.warning.length === 0) {
                            fnc.current.modify(false);
                            let code = data.request;
                            if (formstatus !== "ENTRY FORM") {
                                entrydataRef.current["d_porder_r_hed_no"] = data.request;
                                setedittingcode(data.request);
                                dispatch(changestatus("ENTRY FORM"));
                            }
                            if (newfiles.length !== 0) {        //v1.4
                                //新規ファイルアップロード
                                cfFileUpload("procorderr", code, newfiles, fnc, () => LoadData(code));
                            } else {
                                fnc.current.success();
                                if (formstatus === "ENTRY FORM") {
                                    data.data['rowid'] = Getrowid();    //更新行キー
                                    finallycallback(data.data);
                                }
                                LoadData(code);     //再表示
                            }
                        }
                        else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                        fnc.current.wait(false);
                    },
                    errmsg: "登録に失敗しました"
                }
            )
        }
    }

   function Delete(finallycallback) {
       const param = {
           rowdata: [{ "rowid": edittingcode }],
           controller: controller
       }
        fnc.current.postaxios("procorderr/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }


    //行挿入前イベント
    function QueryInsertRow(row,index) {
        if (formstatus === "ENTRY FORM") {
            //指定行が受け入れ済の場合エラー
            if (isEnabled(row.data.lockrow)) {
                fnc.current.warnmsg("この明細は受入済の為行挿入できません");
                return false;
            }
            //指定行以降に受け入れ済が存在する場合エラー
            for (let i = row.rowIndex + 1; i < rowsRef[index].current.length; i++) {
                if (isEnabled(rowsRef[index].current[i]["lockrow"])) {
                    fnc.current.warnmsg("受入済明細が存在する為行挿入できません");
                    return false;
                }
            }
        }
        return true;
    }
    //行削除前イベント
    function QueryRemoveRow(rows, index) {
        if (formstatus === "ENTRY FORM") {
            for (let i = 0; i < rows.length; i++) {
                if (isEnabled(rows[i].lockrow)) {
                    if (rows.length === 1) fnc.current.warnmsg("この明細は受入済の為行削除できません");
                    else fnc.current.warnmsg("受入済の明細が含まれている為行削除できません");
                    return false;
                }
            }
        }
        return true;
    }

    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }

    //Basic Data Change
    function ValueChanged(params, index) {
        let id = params.column.colId;
        let value = params.newValue;
        if (id === "d_porder_r_splr") {  //仕入先
           if (value === CalcParam[index].current.splrcode) return;
           CalcParam[index].current.splrcode = value;
            if (isEmpty(value)) {
                CalcParam[index].current.amtround = 1;
                CalcParam[index].current.taxround = 1;
                totalRef[index].current[0]["d_porder_r_taxkind"] = "0";
                settaxkind(index);
                RowDataChanged(index);   //再計算
                return;
            }
            let data = fnc.current.getMaster("m_splr", value);
            if (!isEmpty(data)) {
                if ("m_splr_roundamt" in data && "m_splr_roundtax" in data && "m_splr_taxkind" in data) {
                    CalcParam[index].current.amtround = data["m_splr_roundamt"];
                    CalcParam[index].current.taxround = data["m_splr_roundtax"];
                    totalRef[index].current[0]["d_porder_r_taxkind"] = data["m_splr_taxkind"];
                    settaxkind(index);
                    RowDataChanged(index);   //再計算
                    return;
                }
            }
            //仕入先データ取得
            fnc.current.getMasterdata("m_splr", value, "",
                [
                    { columnid: "amtround", dbcolumn: "m_splr_roundamt" },
                    { columnid: "taxround", dbcolumn: "m_splr_roundtax" },
                    { columnid: "taxkind", dbcolumn: "m_splr_taxkind" },
                ], null, (data) => splrApply(data,index))
        }
        if (id === "d_porder_r_date") {  //発注日
            if (value === CalcParam[index].current.taxdate) return;
            CalcParam[index].current.taxdate = value;
            fnc.current.getTaxrate(value, (tax) => taxApply(tax,index));
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
        function taxApply(tax,index) {
            CalcParam[index].current.taxrate = tax;
            RowDataChanged(index);   //再計算
        }
        function splrApply(data,index) {
            if (isEmpty(data)) {
                CalcParam[index].current.amtround = 1;
                CalcParam[index].current.taxround = 1;
                totalRef[index].current[0]["d_porder_r_taxkind"] = "0";
                settaxkind(index);
            } else {
                fnc.current.setMaster(data);
                CalcParam[index].current.amtround = data["m_splr_roundamt"];
                CalcParam[index].current.taxround = data["m_splr_roundtax"];
                totalRef[index].current[0]["d_porder_r_taxkind"] = data["m_splr_taxkind"];
                settaxkind(index);
            }
            RowDataChanged(index);   //再計算
        }
        function settaxkind(index) {
            if (EmptyPanel(G_id.TOTAL)) return;
            if (isEmpty(apitotal[index].grid)) return;
            let rowNode = apitotal[index].grid.getRowNode("TOTAL");
            if (!isEmpty(rowNode)) {
                rowNode.setDataValue("d_porder_r_taxkind", totalRef[index].current[0]["d_porder_r_taxkind"]);
            }
        }
    }
    function TotalValueChange(params, index) {
        if (params.column.colId === "d_porder_r_taxkind") {
            RowDataChanged(index);
        }
        if (params.column.colId === "d_porder_r_rate") { //レート
            RowDataChanged(index,true);
        }
    }
    //投入Grid Data Change
    function ChangeInputValue(params, index) {
        storeRowData(G_id.INPUT);
        let rowidx = params.node.rowIndex;
        if (params.column.colId === "d_porder_r_in_code") {
            //C/#、サイズクリア
            inputRef.current[rowidx]["d_porder_r_in_colno"] = "";
            inputRef.current[rowidx]["d_porder_r_in_colnm"] = "";
            let node = apiinput.grid.getDisplayedRowAtIndex(rowidx);
            if (!isEmpty(node)) {
                node.setData(inputRef.current[rowidx]);
            }
        }
        if (params.column.colId === "d_porder_r_in_qty" || params.column.colId === "d_porder_r_in_price") {
            InputDataChanged();
        }
        storeRowData(G_id.INPUT);
    }
    function InputValueChanged(colid, targets) {
        if (colid === "d_porder_r_in_code") {
            for (let i = 0; i < targets.length; i++) {
                //C/#、サイズクリア
                targets[i]["d_porder_r_in_colno"] = "";
                targets[i]["d_porder_r_in_colnm"] = "";
                var node = apiinput.grid.getRowNode(targets[i].rowid);
                if (!isEmpty(node)) {
                    node.setData(targets[i]);
                }
            }
        }
        InputDataChanged();
    }
    function InputDataChanged() {
        if (isEmpty(apiinput.grid)) return;
        if (isEmpty(inputRef.current)) inputRef.current = [];
        //金額セット
        for (let i = 0; i < inputRef.current.length; i++) {
            let amount = NumConv(inputRef.current[i]["d_porder_r_in_qty"]) * NumConv(inputRef.current[i]["d_porder_r_in_price"]);
            amount = GetRound(amount, CalcParam[0].current.amtround);
            //金額＝数量×単価
            inputRef.current[i]["d_porder_r_in_intax"] = 0;
            inputRef.current[i]["d_porder_r_in_amount"] = amount;

            var node = apiinput.grid.getDisplayedRowAtIndex(i);
            if (!isEmpty(node)) node.setDataValue("d_porder_r_in_amount", inputRef.current[i]["d_porder_r_in_amount"]);
        }
    }

    //Grid Data Change
    function ChangeRowValue(params, index) {
        storeRowData(G_id.Row,index);
        let rowidx = params.node.rowIndex;
        if (params.column.colId === "d_porder_r_row_code") {
            //C/#、サイズクリア
            rowsRef[index].current[rowidx]["d_porder_r_row_colno"] = "";
            rowsRef[index].current[rowidx]["d_porder_r_row_colnm"] = "";
            rowsRef[index].current[rowidx]["d_porder_r_row_size"] = "";
            rowsRef[index].current[rowidx]["d_porder_r_row_sizenm"] = "";
            let node = apirow[index].grid.getDisplayedRowAtIndex(rowidx);
            if (!isEmpty(node)) {
                node.setData(rowsRef[index].current[rowidx]);
            }
        }
        if (params.column.colId === "d_porder_r_row_qty" || params.column.colId === "d_porder_r_row_price") {
            RowDataChanged(index);
        }
        if (params.column.colId === "d_porder_r_row_currency") { //外貨単価
            RowDataChanged(index, true);
        }
        storeRowData(G_id.Row,index);
    }

    function RowValueChanged(colid, targets,index) {
        if (colid === "d_porder_r_row_code" ) {
            for (let i = 0; i < targets.length; i++) {
                //C/#、サイズクリア
                targets[i]["d_porder_r_row_colno"] = "";
                targets[i]["d_porder_r_row_colnm"] = "";
                var node = apirow[index].grid.getRowNode(targets[i].rowid);
                if (!isEmpty(node)) {
                    node.setData(targets[i]);
                }
            }
        }
        RowDataChanged(index);
    }
    //Grid Row Data Change
    function RowDataChanged(index, priceconv) {
        if (isEmpty(apirow[index].grid)) return;
        if (isEmpty(rowsRef[index].current)) rowsRef[index].current = [];
        //金額セット
        for (let i = 0; i < rowsRef[index].current.length; i++) {
            if (isEnabled(priceconv)) {
                if (("d_porder_r_row_currency" in rowsRef[index].current[i]) && ("d_porder_r_rate" in totalRef[index].current[0])) {
                    //単価＝レート×外貨単価　※レート、外貨単価が０の場合変更なし
                    if (NumConv(rowsRef[index].current[i]["d_porder_r_row_currency"] > 0 && NumConv(totalRef[index].current[0]["d_porder_r_rate"]) > 0)) {
                        let price = NumConv(totalRef[index].current[0]["d_porder_r_rate"]) * NumConv(rowsRef[index].current[i]["d_porder_r_row_currency"]);
                        price = GetRound(price, CalcParam[index].current.amtround);
                        rowsRef[index].current[i]["d_porder_r_row_price"] = price;
                    }
                }
            }
            let amount = NumConv(rowsRef[index].current[i]["d_porder_r_row_qty"]) * NumConv(rowsRef[index].current[i]["d_porder_r_row_price"]);
            amount = GetRound(amount, CalcParam[index].current.amtround);
            let taxfree = 0;
            if ("d_porder_r_row_taxfree" in rowsRef[index].current[i])
                taxfree = NumConv(rowsRef[index].current[i]["d_porder_r_row_taxfree"]);
            if (totalRef[index].current[0]["d_porder_r_taxkind"] === "1") {    //内税
                let intax = 0;
                if (taxfree === 0) {    //課税
                    //内税額＝税率 /（1 + 税率）* (d_porder_r_row_qty * d_porder_r_row_price)
                    intax = CalcParam[index].current.taxrate / (1 + CalcParam[index].current.taxrate) * amount;
                    intax = GetRound(intax, CalcParam[index].current.taxround);
                }
                rowsRef[index].current[i]["d_porder_r_row_intax"] = intax;
                rowsRef[index].current[i]["d_porder_r_row_amount"] = amount - intax;
            } else {
                //金額＝数量×単価
                rowsRef[index].current[i]["d_porder_r_row_intax"] = 0;
                rowsRef[index].current[i]["d_porder_r_row_amount"] = amount;
            }
            //外貨金額＝数量×外貨単価
            let curamt = 0;
            if ("d_porder_r_row_currency" in rowsRef[index].current[i]) {
                curamt = NumConv(rowsRef[index].current[i]["d_porder_r_row_qty"]) * NumConv(rowsRef[index].current[i]["d_porder_r_row_currency"]);
                let col = columninfo.find(e => e.columnid === "d_porder_r_row_currency");
                if (!isEmpty(col)) {
                    curamt = GetDesitRound(curamt, CalcParam[index].current.amtround, col.decimalplace);
                }
            }
            rowsRef[index].current[i]["d_porder_r_row_currencyamt"] = curamt;

            var node = apirow[index].grid.getDisplayedRowAtIndex(i);
            if (!isEmpty(node)) node.setDataValue("d_porder_r_row_amount", rowsRef[index].current[i]["d_porder_r_row_amount"]);
        }
        if (EmptyPanel(G_id.TOTAL)) return;
        let total = { qty: 0, amt: 0, taxamt: 0, tax: 0, curamt: 0 };
        for (let i = 0; i < rowsRef[index].current.length; i++) {
            let taxfree = 0;
            if ("d_porder_r_row_taxfree" in rowsRef[index].current[i])
                taxfree = NumConv(rowsRef[index].current[i]["d_porder_r_row_taxfree"]);
            total.qty += NumConv(rowsRef[index].current[i]["d_porder_r_row_qty"]);
            total.amt += NumConv(rowsRef[index].current[i]["d_porder_r_row_amount"]);
            if (taxfree === 0) {    //課税対象分
                total.taxamt += NumConv(rowsRef[index].current[i]["d_porder_r_row_amount"]);
            }
            total.tax += NumConv(rowsRef[index].current[i]["d_porder_r_row_intax"]);
            total.curamt += NumConv(rowsRef[index].current[i]["d_porder_r_row_currencyamt"]);
        }
        totalRef[index].current[0]["d_porder_r_qty"] = total.qty;
        totalRef[index].current[0]["d_porder_r_amount"] = total.amt;
        if (totalRef[index].current[0]["d_porder_r_taxkind"] === "0") {    //外税
            totalRef[index].current[0]["d_porder_r_tax"] = GetRound(CalcParam[index].current.taxrate * total.taxamt, CalcParam[index].current.taxround);
        }
        if (totalRef[index].current[0]["d_porder_r_taxkind"] === "1") {    //内税
            totalRef[index].current[0]["d_porder_r_tax"] = total.tax;
        }
        if (totalRef[index].current[0]["d_porder_r_taxkind"] === "2") {    //非課税
            totalRef[index].current[0]["d_porder_r_tax"] = 0;
        }
        totalRef[index].current[0]["d_porder_r_taxinamt"] = total.amt + NumConv(totalRef[index].current[0]["d_porder_r_tax"]);
        totalRef[index].current[0]["d_porder_r_currencyamt"] = total.curamt;
        let rowNode = apitotal[index].grid.getRowNode("TOTAL");
        if(!isEmpty(rowNode)) rowNode.setData(totalRef[index].current[0]);
    }
    //行データ保持
    function storeRowData(panel, index) {
        if (panel === undefined) {
            for (let i = 0; i < 5; i++) {
                rowsRef[i].current = AGRef.current.GetDatasource(apirow[i].grid);
            }
            inputRef.current = AGRef.current.GetDatasource(apiinput.grid);
        }
        if (panel === G_id.ROW) {
            rowsRef[index].current = AGRef.current.GetDatasource(apirow[index].grid);
        }
        if (panel === G_id.INPUT) {
            inputRef.current = AGRef.current.GetDatasource(apiinput.grid);
        }
    }

    //加工発注挿入/削除
    function SlipMenu(Action, index) {
        //Index以降に受け入れ済データが存在する場合エラー
        for (let i = index; i < 5; i++) {
            if (!rowDragManaged(i)) {
                if (Action === 0) {
                    fnc.current.warnmsg("受入済データが存在するため挿入できません");
                } else {
                    fnc.current.warnmsg("受入済データが存在するためこの加工発注は削除できません");
                }
                return;
            }
        }

        if (Action === 0) {
            fnc.current.confmsg("加工発注" + (index + 1).toString() + "以降を下にシフトします。現在の加工発注-5は破棄されます。よろしいですか？", () => InsertApply(index));
        } else {
            fnc.current.confmsg("加工発注" + (index + 1).toString() + "を削除します。よろしいですか？", () => DeleteApply(index));
        }
        function InsertApply(index) {
            for (let i = 3; i >= index; i--) {
                rowsRef[i+1].current = DeepCopy(rowsRef[i].current);
                totalRef[i+1].current = DeepCopy(totalRef[i].current);
                headerRef[i+1].current = DeepCopy(headerRef[i].current);
                CalcParam[i+1].current = DeepCopy(CalcParam[i].current);
            }
            rowsRef[index].current = [{ rowid: RandomKey() }];
            CalcParam[index].current = { taxrate: 0.1, amtround: 1, taxround: 1 };
            totalRef[index].current = [{ rowid: "TOTAL", grip: "計", d_porder_r_taxkind: "0" }];
            headerRef[index].current = [{ rowid: "HED", grip: "" }];
            for (let i = index; i < 5; i++) {
                apirow[i].grid.setGridOption('rowData', rowsRef[i].current);
                apitotal[i].grid.setGridOption('rowData', totalRef[i].current);
                apiheader[i].grid.setGridOption('rowData', headerRef[i].current);
            }
        }
        function DeleteApply(index) {
            for (let i = index; i < 4; i++) {
                rowsRef[i].current = DeepCopy(rowsRef[i + 1].current);
                totalRef[i].current = DeepCopy(totalRef[i + 1].current);
                headerRef[i].current = DeepCopy(headerRef[i + 1].current);
                CalcParam[i].current = DeepCopy(CalcParam[i + 1].current);
            }
            rowsRef5.current = [{ rowid: RandomKey() }];
            CalcParam5.current = { taxrate: 0.1, amtround: 1, taxround: 1 };
            totalRef5.current = [{ rowid: "TOTAL", grip: "計", d_porder_r_taxkind: "0" }];
            headerRef5.current = [{ rowid: "HED", grip: "" }];
            for (let i = index; i < 5; i++) {
                apirow[i].grid.setGridOption('rowData', rowsRef[i].current);
                apitotal[i].grid.setGridOption('rowData', totalRef[i].current);
                apiheader[i].grid.setGridOption('rowData', headerRef[i].current);
            }
        }
    }

    function Jump(id, type, index) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.ROW) panelid = 'hederGrid_' + index;
        if (id === G_id.INPUT) panelid = 'inputGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //発注データREF初期化
    function initRef() {
        rowsRef1.current = [{ rowid: RandomKey() }];
        rowsRef2.current = [{ rowid: RandomKey() }];
        rowsRef3.current = [{ rowid: RandomKey() }];
        rowsRef4.current = [{ rowid: RandomKey() }];
        rowsRef5.current = [{ rowid: RandomKey() }];
        CalcParam1.current = { taxrate: 0.1, amtround: 1, taxround: 1 };
        CalcParam2.current = { taxrate: 0.1, amtround: 1, taxround: 1 };
        CalcParam3.current = { taxrate: 0.1, amtround: 1, taxround: 1 };
        CalcParam4.current = { taxrate: 0.1, amtround: 1, taxround: 1 };
        CalcParam5.current = { taxrate: 0.1, amtround: 1, taxround: 1 };
        totalRef1.current = [{ rowid: "TOTAL1", grip: "計", d_porder_r_taxkind: "0" }];
        totalRef2.current = [{ rowid: "TOTAL2", grip: "計", d_porder_r_taxkind: "0" }];
        totalRef3.current = [{ rowid: "TOTAL3", grip: "計", d_porder_r_taxkind: "0" }];
        totalRef4.current = [{ rowid: "TOTAL4", grip: "計", d_porder_r_taxkind: "0" }];
        totalRef5.current = [{ rowid: "TOTAL5", grip: "計", d_porder_r_taxkind: "0" }];
        headerRef1.current = [{ rowid: "HED1", grip: "" }];
        headerRef2.current = [{ rowid: "HED2", grip: "" }];
        headerRef3.current = [{ rowid: "HED3", grip: "" }];
        headerRef4.current = [{ rowid: "HED4", grip: "" }];
        headerRef5.current = [{ rowid: "HED5", grip: "" }];
    }
    //入力フィールドクリア
    function clearform(newform) {
        setsliplock(false);
        entrydataRef.current = initializedata(textfieldsall, staff);
        inputRef.current = [{ rowid: RandomKey() }];
        initRef();
        dispatch(setimagelist([]));
        imageRef.current = null;
        fileRef.current = null;
        fnc.current.modify(false);
        //列情報初期化
        inputcolRef.current = null;
        headercolRef.current = null;
        colRef.current = null;
        totalcolRef.current = null;

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        AGRef.current.SaveColState(statusKey(G_id.ROW), EmptyPanel(G_id.ROW) ? null : apirow.column);
        AGRef.current.SaveColState(statusKey(G_id.TOTAL), EmptyPanel(G_id.TOTAL) ? null : apitotal.column);
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    function EmptyPanel(id, type) {
        try {
            let tbltype = tabletype(id);
            return isEmpty(columns.find(e => e.type === tbltype));
        } catch { return false; }
    }
    //パネル別列情報取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T" || id.substr(0, 1) === "H") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.ROW:
                    cols = AGRef.current.GetshownColDef(apirow.column);
                    break;
                default:
                    continue;
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        //Total Grid
        cols = AGRef.current.GetshownColDef(apitotal.column);
        for (let i = 0; i < cols.length; i++) {
            let col = DeepCopy(cols[i]);
            col.type = tabletype(G_id.TOTAL);
            coldef.push(col);
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    var type = tabletype(G_id.ROW);
                    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    colRef.current = coldef;
                    type = tabletype(G_id.TOTAL);
                    coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    totalcolRef.current = coldef;
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }
    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type, pnl.index)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.INPUT) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="inputGrid"
                    entrydataRef={entrydataRef}
                    dataRef={inputRef}
                    columnRef={inputcolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.INPUT)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={formid + "entry_" + G_id.INPUT}
                    ValueChanged={ChangeInputValue}
                    RowValueChanged={InputValueChanged}
                />
            );
        }
        if (props.panel.id === G_id.ROW) {
                return (
                    <React.Fragment>
                        {EmptyPanel(G_id.HEADER) ? null :
                            <EntryGrid
                                id={"H" + props.panel.id + "_" + props.panel.index}
                                elemid={"hederGrid_" + props.panel.index}
                                dataRef={headerRef[props.panel.index]}
                                columnRef={headercolRef}
                                columninfo={columninfo}
                                columns={columns}
                                type={tabletype(G_id.HEADER)}
                                fnc={fnc}
                                onFirstDataRendered={(e,id)=>onFirstDataRendered(e, id, props.panel.index)}
                                statusKey={formid + "entry_" + G_id.HEADER}
                                ValueChanged={(e)=>ValueChanged(e,props.panel.index)}
                                total={true}
                                nogriptitle={true}
                            />
                        }
                        <EntryGrid
                            id={props.panel.id + "_" + props.panel.index}
                            elemid={"rowGrid_" + props.panel.index}
                            entrydataRef={entrydataRef}
                            dataRef={rowsRef[props.panel.index]}
                            columnRef={colRef}
                            columninfo={columninfo}
                            columns={columns}
                            type={tabletype(G_id.ROW)}
                            fnc={fnc}
                            onFirstDataRendered={(e,id) => onFirstDataRendered(e, id, props.panel.index)}
                            statusKey={formid + "entry_" + G_id.ROW}
                            ValueChanged={(e)=>ChangeRowValue(e, props.panel.index)}
                            RowValueChanged={(colid, targets) => RowValueChanged(colid, targets, props.panel.index)}
                            RemoveRow={()=>RowDataChanged(props.panel.index)}
                            ColdefSpecial={ColdefSpecial}
                            rowDragManaged={rowDragManaged(props.panel.index)}
                            QueryRemoveRow={(p) => QueryRemoveRow(p, props.panel.index)}
                            QueryInsertRow={(p) => QueryInsertRow(p, props.panel.index)}
                        />
                        {EmptyPanel(G_id.TOTAL) ? null :
                            <EntryGrid
                                id={"T" + props.panel.id + "_" + props.panel.index}
                                elemid={"totalGrid_" + props.panel.index}
                                dataRef={totalRef[props.panel.index]}
                                columnRef={totalcolRef}
                                columninfo={columninfo}
                                columns={columns}
                                type={tabletype(G_id.TOTAL)}
                                fnc={fnc}
                                onFirstDataRendered={(e,id) => onFirstDataRendered(e, id, props.panel.index)}
                                statusKey={formid + "entry_" + G_id.TOTAL}
                                ValueChanged={()=>TotalValueChange(props.panel.index)}
                                total={true}
                            />
                        }
                    </React.Fragment>
                );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        return null;

    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name === '' ? <div style={{ display: 'inline-block', height: 10 }}></div> : p.name}
                                    {p.name2 !== '' ? '-' : ''}
                                    <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose?null:
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                        <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                            <Icon style={{ fontSize: 16 }}>close</Icon>
                                        </IconButton>
                                        </div>
                                    }
                                    {p.id === G_id.ROW ?
                                        <div style={{ position: 'absolute', left: 200, top: -5 }}>
                                            {formlock ? null :
                                                <React.Fragment>
                                                <IconButton size="small" onClick={() => SlipMenu(0,p.index)} title="加工発注挿入">
                                                        <Icon style={{ fontSize: 23 }}>create_new_folder</Icon>
                                                </IconButton>
                                                <IconButton size="small" onClick={() => SlipMenu(1,p.index)} title="加工発注削除">
                                                        <Icon style={{ fontSize: 23 }}>rule_folder</Icon>
                                                </IconButton>
                                                </React.Fragment>
                                            }
                                        </div>
                                        : null   }
                              </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                        );
                    })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_porder_r'}
                primarykey={primarykeys}
                parentedit={true}
                navmenu={formlock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                listcellchange={ListCellChange}
                slipsave={true}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};
